export default __webpack_public_path__ + "static/media/basket-banner.a2bca878.gif";